import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/CCMBankForsikring.png";

function CCMBankForsikring() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.bankInsurance.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.bankInsurance.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/ccm-for-bank-og-forsikring"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.bankInsurance.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.bankInsurance.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.bankInsurance.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.bankInsurance.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p>{i18next.t("pages.articles.list.bankInsurance.sections.intro.content")}
              <a href="/ccm" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.bankInsurance.sections.intro.link")}
              </a>
              {i18next.t("pages.articles.list.bankInsurance.sections.intro.content2")}
            </p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.bankInsurance.sections.advantages.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.bankInsurance.sections.advantages.intro")}</p>
            <ul className="list-disc list-outside ml-6">
              <li>{i18next.t("pages.articles.list.bankInsurance.sections.advantages.features.1")}</li>
              <li>{i18next.t("pages.articles.list.bankInsurance.sections.advantages.features.2")}</li>
              <li>{i18next.t("pages.articles.list.bankInsurance.sections.advantages.features.3")}</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.bankInsurance.sections.eaa.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.bankInsurance.sections.eaa.content")}</p>

            <p className="mt-6">
              <a href="/artikler/gjor-dokumentene-dine-tilgjengelige" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.bankInsurance.sections.link.text")}
              </a>
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.bankInsurance.sections.conclusion.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.bankInsurance.sections.conclusion.content")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CCMBankForsikring;

